import { themes as commonThemes } from '@sitebuilder/common';

export interface ThemeData {
    userFonts?: Array<{ name: string } | string>;
    defaultColors?: Record<string, string>;
    colors?: Record<string, string>;
}

export const useThemeData = () => {
    // Get theme data (try to access Redux state)
    const getThemeData = (): ThemeData | null => {
        try {
            // Check if we're in a browser environment (not SSR)
            if (typeof window === 'undefined') {
                return null;
            }

            const store = (window as any).__REDUX_STORE__;
            if (store && store.getState) {
                const state = store.getState();
                return state?.themes?.theme || null;
            }
        } catch (error) {
            console.log('Could not access theme data:', error);
        }
        return null;
    };

    const themeData = getThemeData();

    // Get all available fonts including theme fonts
    const getAllFonts = (): Array<{ name: string } | string> => {
        const fonts: Array<{ name: string } | string> = [...commonThemes.defaultFonts];
        if (themeData?.userFonts) {
            fonts.push(...themeData.userFonts);
        }
        return fonts;
    };

    // Get all available color variables
    const getColorVariables = () => {
        const colors: any = {
            ...commonThemes.defaultColors,
        };

        if (themeData) {
            Object.assign(colors, themeData.defaultColors, themeData.colors);
        }

        return Object.keys(colors).filter((key) => key && colors[key]);
    };

    // Get color variables with their actual values
    const getColorVariablesWithValues = (): Array<{ key: string; value: string }> => {
        const colors: any = {
            ...commonThemes.defaultColors,
        };

        if (themeData) {
            Object.assign(colors, themeData.defaultColors, themeData.colors);
        }

        const colorEntries: Array<{ key: string; value: string }> = [];
        Object.keys(colors).forEach((key) => {
            if (key && colors[key]) {
                colorEntries.push({
                    key: key,
                    value: colors[key],
                });
            }
        });

        return colorEntries;
    };

    return {
        themeData,
        getAllFonts,
        getColorVariables,
        getColorVariablesWithValues,
    };
};
